import React, { useState, useRef, useEffect } from "react";
import { Download } from "lucide-react";
import Tooltip from "../../../../../components/Tooltip/Tooltip";

export type ExportFormat = "excel" | "excel-grouped" | "pdf" | "csv";

interface Props {
  onExport: (format: ExportFormat) => void;
}

export default function ExportMenu({ onExport }: Props) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const h = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [open]);

  const pick = (f: ExportFormat) => { onExport(f); setOpen(false); };

  return (
    <div className="relative" ref={ref}>
      <Tooltip label="Export">
        <button type="button" onClick={() => setOpen((o) => !o)} className="w-8 h-8 rounded-md inline-flex items-center justify-center text-ink2 hover:bg-[#EEF4FB] hover:text-ink">
          <Download className="w-4 h-4" />
        </button>
      </Tooltip>
      {open && (
        <div className="absolute top-full right-0 mt-1 bg-white border border-[#D8DEE6] rounded-lg shadow-lg z-50 py-1 min-w-[220px]">
          <Item onClick={() => pick("excel")}>Export to Excel</Item>
          <Item onClick={() => pick("excel-grouped")}>Export to Excel (with grouping)</Item>
          <Item onClick={() => pick("pdf")}>Export to PDF</Item>
          <Item onClick={() => pick("csv")}>Export as CSV</Item>
        </div>
      )}
    </div>
  );
}

function Item({ onClick, children }: { onClick: () => void; children: React.ReactNode }) {
  return <button type="button" onClick={onClick} className="w-full text-left px-3.5 py-2 text-[12.5px] text-ink hover:bg-[#EEF4FB]">{children}</button>;
}